import uuidv4 from 'uuid';

const PARENTHESIS_MATCH_REGEX = /\(([^)]+)\)/;
const TURKISH_CHARACTERS = ['ğ', 'ü', 'ş', 'ı', 'ö', 'ç', 'Ğ', 'Ü', 'Ş', 'İ', 'I', 'Ö', 'Ç'];
const MAPPED_TURKISH_CHARACTERS = ['g', 'u', 's', 'i', 'o', 'c', 'G', 'U', 'S', 'I', 'I', 'O', 'C'];

function extractTextBetweenParantheses(input) {
  let extractedText = '';
  if (input) {
    const matchedText = input.match(PARENTHESIS_MATCH_REGEX);
    if (matchedText && matchedText.length > 1) {
      extractedText = matchedText[1];
    }
  }
  return extractedText;
}

function generateRandomGuid() {
  return uuidv4();
}

function turkishCharacterConverter(input) {
  if(!input) {
    return '';
  }
  let str = input.split('');

  for (let i = 0; i < str.length; i++) {
    let c = TURKISH_CHARACTERS.indexOf(str[i]);
    if(c >= 0) {
      str[i] = MAPPED_TURKISH_CHARACTERS[c];
    }
  }

  return str.join('');
}

function convertSentenceFormat(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function hexToString(hex) {
  let string = '';
  for (let i = 0; i < hex.length; i += 2) {
    string += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
  }
  return string;
}

function stringReplace(text, values) {
  const templateSplit = new RegExp(/{{(.*?)}}/g);
  const splittedText = text.split(templateSplit);

  return splittedText.map((item, index) => {
    if(values && values[item]){
      return values[item](index);
    }
    return item
  });
}

export {
  extractTextBetweenParantheses,
  turkishCharacterConverter,
  generateRandomGuid,
  convertSentenceFormat,
  hexToString,
  stringReplace,
};
